const fields = [
  'Stage Date',
  'Stage Date & Time',
  'Comments',
  'Events',
  'Other Documents',
  'Joining Date',
  'Offer Payrate',
];

export const getFieldFromSelectedStatus = (stagesData, selectedStage, selectedStatus) => {
  return fields.filter(
    (field) =>
      stagesData &&
      stagesData
        .find((stage) => stage.stage === selectedStage)
        ?.statuses.find((status) => status.value === selectedStatus)
        ?.mandatoryFields?.includes(field)
  );
};
